module.exports = __webpack_public_path__ + "static/gyoza-1be237cdd3d355cff1bd7f1c7cbf4ee8.jpg";